export enum ButlerType {
  inHouse = 1,
  thirdParty = 2,
}
